import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import { setToken, getToken,canTurnTo } from '@/libs/utils'
Vue.use(Router);
const router = new Router({
  routes,
  mode: 'history'
});
const LOGIN_PAGE_NAME = 'login';

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next() ;// 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
};
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
};
router.beforeEach((to, from, next) => {
  const token = getToken();
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页,定向到交易页面
    next({
      name: 'trade' // trade
    })
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next)
    } else {
      store.dispatch('getUserInfo').then(user => {
        if(user.msg==="token过期"){
          setToken('');
          next({
            name: 'login'
          })
        }else {
          // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
          turnTo(to, user.access, next)
        }
      }).catch(() => {
        setToken('');
        next({
          name: 'login'
        })
      })
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js